module.exports = __webpack_public_path__ + "img/banner-middle-3.863ec9c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/banner-middle/banner-middle-3.jpg
// module id = cC6D
// module chunks = 1